import { NotificationService } from './notification.service';

export const SERVICES = [
  NotificationService
];
